import { render, staticRenderFns } from "./LoginLegalModal.vue?vue&type=template&id=4563ebfd"
import script from "./LoginLegalModal.vue?vue&type=script&lang=js"
export * from "./LoginLegalModal.vue?vue&type=script&lang=js"
import style0 from "./LoginLegalModal.vue?vue&type=style&index=0&id=4563ebfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports